var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-full border-primary-200 border-t-4",attrs:{"id":"app"}},[_c('v-app',{style:({ background: '#f0f8ff' })},[_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.loading)?_c('Global-Spinner',{attrs:{"loading":_vm.loading}}):_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }